import React from "react";

import Button from "src/components/button";
import { Col } from "react-bootstrap";

import ThemeCustomization from "./components/customization/theme.jsx";
import LibrarySettings from "./components/customization/library.jsx";
import ReshareEmailCustomization from "./components/customization/reshareEmail.jsx";

import TextCustomization from "./components/customization/textCustomization.jsx";
import PasswordProtect from "../../../images/fliteviewSettings/passwordProtect.png";
import Gating from "../../../images/fliteviewSettings/gating.png";
import Nda from "../../../images/fliteviewSettings/nda.png";

import DefaultFooterMessageTemplate from "src/templates/DefaultFooterMessage.handlebars.js";
import AlertMessageIcon from "../../../images/alert_message.png";
import { Alert, Image } from "react-bootstrap";
import _ from "lodash";
import Toast from "src/components/toast";
import { toast } from "react-toastify";
import {
  GALLERY_VIEWER,
  IMMERSE_VIEWER,
  LIST_VIEWER,
} from "../../../constants/collectionConstants";
import OldViewerType from "../../../images/list_viewer.svg";
import NewViewerType from "../../../images/immerse_viewer.svg";
import GalleryViewerType from "../../../images/gallery_viewer.svg";
import { localizedStrings } from "../../../../localization";

import cx from "classnames";
import styles from "./FliteviewSettingsView.module.scss";

class FliteviewSettingsView extends React.Component {
  constructor(props) {
    super(props);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedViewerSettings =
      this.localizedSettings.account.viewer_settings;

    this.state = {
      showToast: false,
      ...this.props.account,
      librarySettings: {
        ...this.props.account.librarySettings,
        reshareEmail:
          _.get(this.props.librarySettings, "reshareEmail") ||
          this.defaultFooterMessage(),
        banner: _.get(this.props.librarySettings, "banner"),
        passwordText: {
          heading:
            _.get(this.props.librarySettings, "passwordText.heading") ||
            `<p>${this.localizedViewerSettings.library_settings.password_protected.heading}</p>`,
          descriptionText:
            _.get(this.props.librarySettings, "passwordText.descriptionText") ||
            "<p></p>",
          buttonText:
            _.get(this.props.librarySettings, "passwordText.buttonText") ||
            this.localizedCommons.continue.toUpperCase(),
        },
        gatingText: {
          heading:
            _.get(this.props.librarySettings, "gatingText.heading") ||
            `<p>${this.localizedViewerSettings.library_settings.gating_customization.heading}</p>`,
          descriptionText:
            _.get(this.props.librarySettings, "gatingText.descriptionText") ||
            `<p>${this.localizedViewerSettings.library_settings.gating_customization.description_text}</p>`,
          buttonText:
            _.get(this.props.librarySettings, "gatingText.buttonText") ||
            this.localizedCommons.continue.toUpperCase(),
        },
        ndaText: {
          heading:
            _.get(this.props.librarySettings, "ndaText.heading") ||
            this.localizedViewerSettings.library_settings.nda_customization
              .heading,
          descriptionText:
            _.get(this.props.librarySettings, "ndaText.descriptionText") ||
            `<p>${this.localizedViewerSettings.library_settings.nda_customization.description_text}</p>`,
          buttonText:
            _.get(this.props.librarySettings, "ndaText.buttonText") ||
            this.localizedCommons.continue.toUpperCase(),
        },
        otpText: {
          heading:
            _.get(this.props.librarySettings, "otpText.heading") ||
            this.localizedViewerSettings.library_settings.otp.heading,
          descriptionText:
            _.get(this.props.librarySettings, "otpText.descriptionText") ||
            this.localizedViewerSettings.library_settings.otp.sub_text,
          buttonText:
            _.get(this.props.librarySettings, "otpText.buttonText") ||
            this.localizedCommons.continue.toUpperCase(),
        },
        assetViewer: this.props.assetViewer || LIST_VIEWER,
      },
      reshareEmailError: null,
      showError: false,
    };
    this.handleThemeChange = this.handleThemeChange.bind(this);
    this.handlePasswordTextChange = this.handlePasswordTextChange.bind(this);
    this.handleGatingTextChange = this.handleGatingTextChange.bind(this);
    this.handleNdaTextChange = this.handleNdaTextChange.bind(this);
    this.handleOtpTextChange = this.handleOtpTextChange.bind(this);
    this.handleLogoChange = this.handleLogoChange.bind(this);
    this.handleLibrarySettingsChange =
      this.handleLibrarySettingsChange.bind(this);

    this._handleUpdateClick = this._handleUpdateClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.handleReshareEmailChange = this.handleReshareEmailChange.bind(this);
    this.validateReshareEmail = this.validateReshareEmail.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
    this.handleViewerChange = this.handleViewerChange.bind(this);
  }

  componentDidMount() {
    this.renderDefaultSettings();
  }

  componentWillReceiveProps(nextProps) {
    if (
      !_.isEqual(this.props.updated, nextProps.updated) &&
      nextProps.updated
    ) {
      toast(
        <Toast.Sucess
          message={this.localizedSettings.toast.fliteview_update.success}
          className={styles.toasters}
        />,
        {
          draggable: true,
          autoClose: 3000,
        },
      );
    }
    if (this.props.error) {
      toast(
        <Toast.Failure
          heading={this.localizedCommons.error}
          description={this.localizedSettings.toast.fliteview_update.failure}
          className={styles.toasters}
          toast={toast}
        />,
        {
          autoClose: 3000,
        },
      );
    }
  }

  renderDefaultSettings() {
    const librarySettings = this.localizedViewerSettings.library_settings;

    let passwordText = _.get(this.props.librarySettings, "passwordText");
    let gatingText = _.get(this.props.librarySettings, "gatingText");
    let ndaText = _.get(this.props.librarySettings, "ndaText");

    let otpText = _.get(this.props.librarySettings, "otpText");

    this.setState({
      ...this.props.account,
      librarySettings: {
        ...this.state.librarySettings,
        primaryColor: this.props.librarySettings.primaryColor || "#e51058",
        buttonTextColor:
          this.props.librarySettings.buttonTextColor || "#717274",
        shareText:
          this.props.librarySettings.shareText ||
          this.localizedViewerSettings.library_settings.share_collection,
        assetViewRegular: {
          backgroundColor:
            _.get(
              this.props.librarySettings,
              "assetViewRegular.backgroundColor",
            ) || "#ffffff",
          textColor:
            _.get(this.props.librarySettings, "assetViewRegular.textColor") ||
            "#000000",
          subTextColor:
            _.get(
              this.props.librarySettings,
              "assetViewRegular.subTextColor",
            ) || "#717274",
          separatorColor:
            _.get(
              this.props.librarySettings,
              "assetViewRegular.separatorColor",
            ) || "#e51058",
        },
        assetViewActive: {
          backgroundColor:
            _.get(
              this.props.librarySettings,
              "assetViewActive.backgroundColor",
            ) || "#000000",
          textColor:
            _.get(this.props.librarySettings, "assetViewActive.textColor") ||
            "#ffffff",
          subTextColor:
            _.get(this.props.librarySettings, "assetViewActive.subTextColor") ||
            "#717274",
        },
        passwordText: {
          ...this.state.librarySettings.passwordText,
          placeHolder: _.isEmpty(passwordText?.placeHolder)
            ? librarySettings.password_protected.placeholder
            : passwordText.placeHolder,
          heading: _.isEmpty(passwordText?.heading)
            ? librarySettings.password_protected.heading
            : passwordText.heading,
          descriptionText: _.isEmpty(passwordText?.descriptionText)
            ? librarySettings.password_protected.description_text
            : passwordText.descriptionText,
          buttonText: _.isEmpty(passwordText?.buttonText)
            ? librarySettings.password_protected.continue
            : passwordText.buttonText,
        },
        gatingText: {
          ...this.state.librarySettings.gatingText,
          placeHolder: _.isEmpty(gatingText?.placeHolder)
            ? librarySettings.gating_customization.placeholder
            : gatingText.placeHolder,
          heading: _.isEmpty(gatingText?.heading)
            ? librarySettings.gating_customization.heading
            : gatingText.heading,
          descriptionText: _.isEmpty(gatingText?.descriptionText)
            ? librarySettings.gating_customization.description_text
            : gatingText.descriptionText,
          buttonText: _.isEmpty(gatingText?.buttonText)
            ? librarySettings.gating_customization.button_text.toUpperCase()
            : gatingText.buttonText,
        },
        ndaText: {
          ...this.state.librarySettings.ndaText,
          placeHolder: _.isEmpty(ndaText?.placeHolder)
            ? librarySettings.nda_customization.placeholder
            : ndaText.placeHolder,
          heading: _.isEmpty(ndaText?.heading)
            ? librarySettings.nda_customization.heading
            : ndaText.heading,
          descriptionText: _.isEmpty(ndaText?.descriptionText)
            ? librarySettings.nda_customization.description_text
            : ndaText.descriptionText,
          buttonText: _.isEmpty(ndaText?.buttonText)
            ? librarySettings.nda_customization.continue
            : ndaText.buttonText,
        },
        otpText: {
          ...this.state.librarySettings.otpText,
          heading: _.isEmpty(otpText?.heading)
            ? librarySettings.otp.heading
            : otpText.heading,
          descriptionText: _.isEmpty(otpText?.descriptionText)
            ? librarySettings.otp.sub_text
            : otpText.descriptionText,
          buttonText: _.isEmpty(otpText?.buttonText)
            ? librarySettings.otp.continue
            : otpText.buttonText,
        },
        assetViewer: this.props.assetViewer || LIST_VIEWER,
        reshareEmail:
          _.get(this.props.librarySettings, "reshareEmail") ||
          this.defaultFooterMessage(),
        banner: _.get(this.props.librarySettings, "banner"),
        message: _.get(this.props.librarySettings, "message") || "<p></p>",
      },
      reshareEmailError: null,
      showError: false,
    });
  }

  defaultFooterMessage() {
    return DefaultFooterMessageTemplate({
      librarySettings: this.props.librarySettings,
    });
  }

  handleThemeChange(changes) {
    this.setState(
      {
        reshareEmailError: null,
        librarySettings: {
          ...this.state.librarySettings,
          ...changes,
        },
      },
      () => {
        if (changes.primaryColor || changes.buttonTextColor) {
          this.handleColorChange();
        }
      },
    );
  }

  handleColorChange() {
    var html = this.state.librarySettings.reshareEmail;

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, "text/html");
    var ctaButtons = doc.querySelectorAll(".widget a");

    ctaButtons.forEach((ctaButton) => {
      ctaButton.style.background = this.state.librarySettings.primaryColor;
      ctaButton.style.border = `10px solid ${this.state.librarySettings.primaryColor}`;
      ctaButton.style.color = this.state.librarySettings.buttonTextColor;
    });

    this.setState({
      librarySettings: {
        ...this.state.librarySettings,
        reshareEmail: doc.body.innerHTML,
      },
    });
  }

  handlePasswordTextChange(textChanges) {
    this.handleThemeChange({
      passwordText: {
        ...this.state.librarySettings.passwordText,
        ...textChanges,
      },
    });
  }

  handleGatingTextChange(textChanges) {
    this.handleThemeChange({
      gatingText: {
        ...this.state.librarySettings.gatingText,
        ...textChanges,
      },
    });
  }

  handleNdaTextChange(textChanges) {
    this.handleThemeChange({
      ndaText: {
        ...this.state.librarySettings.ndaText,
        ...textChanges,
      },
    });
  }

  handleOtpTextChange(textChanges) {
    this.handleThemeChange({
      otpText: {
        ...this.state.librarySettings.otpText,
        ...textChanges,
      },
    });
  }

  handleLogoChange(logo) {
    this.setState({
      logo: logo,
    });
  }

  handleLibrarySettingsChange(changes) {
    this.setState({
      librarySettings: changes,
    });
  }

  handleReshareEmailChange(changes) {
    this.setState({
      librarySettings: {
        ...this.state.librarySettings,
        ...changes,
      },
    });
  }

  validateReshareEmail() {
    let reshareEmail = _.get(this.state.librarySettings, "reshareEmail");
    if (reshareEmail != null && !reshareEmail.includes("collection.cta")) {
      this.setState({
        reshareEmailError:
          this.localizedViewerSettings.library_settings.error_messages.reshare,
        showError: true,
      });
    }
  }

  _handleUpdateClick() {
    if (this.state.reshareEmailError) {
      this.setState({
        showError: true,
      });
      return;
    }

    var librarySettings = this.state.librarySettings || {};

    if (librarySettings) {
      const background = _.get(librarySettings, "banner.background");

      if (typeof background !== "string") {
        librarySettings = _.omit(librarySettings, "banner.background");
      }
    }

    var logo = this.state.logo;
    if (logo) {
      if (typeof logo !== "string") {
        logo = null;
      }
    }

    let account = {
      logo: logo,
      librarySettings: librarySettings,
    };

    this.props.updateAccount(account);
  }

  handleResetClick() {
    this.renderDefaultSettings();
  }

  handleDismiss() {
    this.setState({
      ...this.state.account,
      librarySettings: {
        ...this.state.librarySettings,
        reshareEmail:
          _.get(this.props.librarySettings, "reshareEmail") ||
          this.defaultFooterMessage(),
      },
      reshareEmailError: null,
      showError: false,
    });
  }

  handleViewerChange(viewerType) {
    this.setState({
      librarySettings: {
        ...this.state.librarySettings,
        assetViewer: viewerType,
      },
    });
  }

  render() {
    return (
      <div className={styles.content}>
        <div className={styles.innerContent}>
          <div className={styles.heading}>
            {this.localizedViewerSettings.title}
          </div>
          <DefaultAssetViewer
            assetViewer={this.state.librarySettings.assetViewer}
            onViewerChange={this.handleViewerChange}
          />

          <ThemeCustomization
            librarySettings={this.state.librarySettings}
            onThemeChange={this.handleThemeChange}
            title={this.localizedViewerSettings.customize_theme.title}
            description={this.localizedViewerSettings.customize_theme.sub_text}
          />
          <LibrarySettings
            account={this.props.account}
            value={this.state}
            onChange={this.handleLibrarySettingsChange}
            onLogoChange={this.handleLogoChange}
            title={this.localizedViewerSettings.library_settings.title}
            description={this.localizedViewerSettings.library_settings.sub_text}
          />
          <TextCustomization
            title={
              this.localizedViewerSettings.library_settings.password_protected
                .title
            }
            description={
              this.localizedViewerSettings.library_settings.password_protected
                .sub_text
            }
            previewImage={PasswordProtect}
            librarySettings={this.state.librarySettings}
            onTextChange={this.handlePasswordTextChange}
            text={_.get(this.state.librarySettings, "passwordText")}
            showPlaceholder={true}
            account={this.props.account}
          />
          <TextCustomization
            title={
              this.localizedViewerSettings.library_settings.gating_customization
                .title
            }
            description={
              this.localizedViewerSettings.library_settings.gating_customization
                .sub_text
            }
            previewImage={Gating}
            librarySettings={this.state.librarySettings}
            onTextChange={this.handleGatingTextChange}
            text={_.get(this.state.librarySettings, "gatingText")}
            showPlaceholder={true}
            account={this.props.account}
          />
          <TextCustomization
            title={
              this.localizedViewerSettings.library_settings.nda_customization
                .title
            }
            description={
              this.localizedViewerSettings.library_settings.nda_customization
                .sub_text
            }
            previewImage={Nda}
            librarySettings={this.state.librarySettings}
            onTextChange={this.handleNdaTextChange}
            text={_.get(this.state.librarySettings, "ndaText")}
            showPlaceholder={true}
            account={this.props.account}
          />
          <TextCustomization
            title={this.localizedViewerSettings.library_settings.otp.title}
            description={
              this.localizedViewerSettings.library_settings.otp.sub_text
            }
            previewImage={PasswordProtect}
            librarySettings={this.state.librarySettings}
            onTextChange={this.handleOtpTextChange}
            text={_.get(this.state.librarySettings, "otpText")}
            showPlaceholder={false}
            account={this.props.account}
          />
          <ReshareEmailCustomization
            title={
              this.localizedViewerSettings.library_settings.email_content.title
            }
            description={
              this.localizedViewerSettings.library_settings.email_content
                .sub_text
            }
            onContentChange={this.handleReshareEmailChange}
            text={_.get(this.state.librarySettings, "reshareEmail")}
          />
          <Col md={12} className={styles.buttonTray}>
            <Button
              variant="primary"
              text={
                this.props.updating
                  ? `${this.localizedCommonsActions.saving}...`
                  : this.localizedCommonsActions.save
              }
              disabled={this.props.updating}
              icon="paperflite-tick"
              onClick={this._handleUpdateClick}
            />
            <Button
              variant="secondary"
              text={this.localizedCommonsActions.reset}
              disabled={this.props.updating}
              onClick={this.handleResetClick}
            />
            {this.state.showError && (
              <Alert
                bsStyle="danger"
                className={styles.errorMessage}
                onDismiss={this.handleDismiss}
              >
                <button
                  className={styles.dismissButton}
                  onClick={this.handleDismiss}
                >
                  <span className="lnr lnr-cross"></span>
                </button>
                <Image className={styles.alertImage} src={AlertMessageIcon} />
                <div className={styles.alertText}>
                  {this.state.reshareEmailError}
                </div>
              </Alert>
            )}
          </Col>
        </div>
      </div>
    );
  }
}

const DefaultAssetViewer = (props) => {
  const viewerTypes = [LIST_VIEWER, IMMERSE_VIEWER, GALLERY_VIEWER];

  const localizedSettings = localizedStrings.pages.settings;
  const localizedViewerSettings = localizedSettings.account.viewer_settings;

  const renderCheckbox = (key) => {
    const assetViewer = props.assetViewer || LIST_VIEWER;
    var selected = assetViewer;
    return (
      <i
        className={cx(styles.checkbox, {
          "fa-solid fa-check-circle": selected === key,
          "fa-regular fa-circle": selected !== key,
        })}
        aria-hidden="true"
      ></i>
    );
  };

  const handleCheckboxChange = (viewerType) => {
    const selected = props.assetViewer || LIST_VIEWER;

    if (selected === viewerType) {
      return;
    }

    props.onViewerChange(viewerType);
  };

  const renderOldViewerContent = () => {
    return (
      <div className={styles.viewerContent}>
        <span
          onClick={() => handleCheckboxChange(LIST_VIEWER)}
          className={styles.selection}
        >
          {renderCheckbox(LIST_VIEWER)}
          <span className={styles.viewerTitle}>
            {localizedViewerSettings.default_viewer.list_viewer.title}
          </span>
        </span>
        <div className={styles.description}>
          {localizedViewerSettings.default_viewer.list_viewer.sub_text}
        </div>
        <img className={styles.wireframe} src={OldViewerType} />
      </div>
    );
  };

  const renderNewViewerContent = () => {
    return (
      <div className={styles.viewerContent}>
        <span
          onClick={() => handleCheckboxChange(IMMERSE_VIEWER)}
          className={styles.selection}
        >
          {renderCheckbox(IMMERSE_VIEWER)}
          <span className={styles.viewerTitle}>
            {localizedViewerSettings.default_viewer.immerse_viewer.title}
          </span>
        </span>
        <div className={styles.description}>
          {localizedViewerSettings.default_viewer.immerse_viewer.sub_text}
        </div>
        <img className={styles.wireframe} src={NewViewerType} />
      </div>
    );
  };

  const renderGalleryViewerContent = () => {
    return (
      <div className={styles.viewerContent}>
        <span
          onClick={() => handleCheckboxChange(GALLERY_VIEWER)}
          className={styles.selection}
        >
          {renderCheckbox(GALLERY_VIEWER)}
          <span className={styles.viewerTitle}>
            {" "}
            {localizedViewerSettings.default_viewer.gallery_viewer.title}
          </span>
        </span>
        <div className={styles.description}>
          {localizedViewerSettings.default_viewer.gallery_viewer.sub_text}
        </div>
        <img className={styles.wireframe} src={GalleryViewerType} />
      </div>
    );
  };

  const renderViewerType = (experienceType) => {
    switch (experienceType) {
      case LIST_VIEWER:
        return renderOldViewerContent();

      case IMMERSE_VIEWER:
        return renderNewViewerContent();

      case GALLERY_VIEWER:
        return renderGalleryViewerContent();

      default:
        break;
    }
  };

  return (
    <section className={styles.defaultViewerSection}>
      <div>
        <span className={styles.title}>
          {localizedViewerSettings.default_viewer.title}
        </span>
        <span className={styles.description}>
          {localizedViewerSettings.default_viewer.sub_text}
        </span>
      </div>
      <div className={styles.viewerTypesContent}>
        {viewerTypes.map((item) => {
          return renderViewerType(item);
        })}
      </div>
    </section>
  );
};

export default FliteviewSettingsView;
